import { mergeSharedTranslations } from "@shared/utils/mergeSharedTranslations";
import { sharedUS as sharedUnAuthenticatedUS } from "@unauthenticated/shared/locales";

import { credentials } from "./credentials";
import { oauth } from "./oauth";

export const en = mergeSharedTranslations({
  ...sharedUnAuthenticatedUS,
  oauth,
  credentials,
});
